import { ChangeDetectorRef, Component, ElementRef, HostBinding } from '@angular/core';
import { IWizItemRenderer, WizBaseCollector, WizDatasource, WizEventManager, WizRoot } from '@wizeoo/akm-component-lib';
import { WizDateUtils } from '@wizeoo/akm-core-lib';
import { AlkEvent } from '../../../../../framework/events/alk.event';
import { ALK_EVENT_TYPE } from '../../../../../model/enums';
import { FIELD_KIND, WorkComReply } from '@wizeoo/akm-compute-lib';
import { FakeVO } from '../../../../../vo/common/tool/fake.vo';
import { Model } from '../../../../../model/model';
import { ViewData } from '../../../../../model/view.data';

/**
 * rendu d'un avec une checkbox, une image et un label
 */
@Component({
  selector: 'workcom-message-renderer',
  templateUrl: './workcom-message.renderer.html',
})
export class WorkcomMessageRenderer implements IWizItemRenderer<null, WorkComReply> {
  
  @HostBinding('style.width') width: string = '100%';
  @HostBinding('style.height') height: string = '100%';

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
  }

  public stateDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>(ViewData.getInstance().workflowState)
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .build();



  private _data: WorkComReply;
  public get data(): WorkComReply {
    return this._data;
  }
  public set data(value: WorkComReply) {
    // console.log('set data', value);
    this._data = value;
    this.createBy = this._data.who;
    if(this._data.date) {
      this.createTime = WizDateUtils.dateToLocalizedString(WizDateUtils.stringToDate(this._data.date.toString().substr(0, 8)));
    }
    
    this.content = this._data.content;

    if(this._data.state) {
      let stateVO: FakeVO = this.stateDS.getItemByKey(this._data.state);
      this.state = stateVO.label; // alimentation de la drop des types de données
      this.icon = stateVO.icon;
    }

    if(this._data.startDate) {
      let format = Model.getInstance().formatEngine.getDefaultFormat(FIELD_KIND.DATE);
      this.startDate =  WizDateUtils.dateToString(WizDateUtils.stringToTime(this._data.startDate.toString()), format.dateExp);
    }

    if(this._data.endDate) {
      let format = Model.getInstance().formatEngine.getDefaultFormat(FIELD_KIND.DATE);
      this.endDate =  WizDateUtils.dateToString(WizDateUtils.stringToTime(this._data.endDate.toString()), format.dateExp);
    }
    this.cdref.markForCheck();
  }
  owner: WizBaseCollector;

  public createBy: string = null;
  public createTime: string = null;
  public content: string = null;

  public state: string = null;
  public icon: string = null;
  public startDate: string = null;
  public endDate: string = null;

  public notFirst():boolean {
    return this._data?.idx > 0;
  }

  public get idx():number {
    return this._data?.idx;
  }

  public isMine():boolean {
    return this._data?.who === Model.getInstance().connectedUser?.mail;
  }

  public doDeleteReply(): void {
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.DELETE_WORKCOM_MESSAGE, this.data));
    // console.log('doDeleteReply');
  }

  public doEditReply(): void {
    // console.log('doEditReply', this.data);
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.EDIT_WORKCOM_MESSAGE, {wcr: this.data, callback: this.backFromEdit.bind(this)}));
  }

  public backFromEdit(wcr: WorkComReply): void {
    this.data = wcr;
    // console.log('backFromEdit', wcr);
  }

}
